import { Link } from "react-router-dom";
import decor01 from "./img/decor-01.png";
import decor02 from "./img/decor-02.png";
import decor03 from "./img/decor-03.png";
import PlaceHolderIcon from "./img/placeholder-card-arrow.svg?react";
import "./style.scss";
import DOMPurify from "dompurify";

export default function AwardCardPlaceholder({
  activity,
  href01,
  href02,
  brands,
  topCopy01,
  topCopy02,
  bottomCopy01,
  bottomCopy02,
}) {
  return (
    <div className={`award-card-placeholder`}>
      <div
        className={`card-wrapper ${
          !brands.includes("glo") ? "single-wrapper" : ""
        }`}
      >
        <div className="flex-holder">
          <div
            className={`part part-top ${
              !brands.includes("glo") ? "single" : ""
            }`}
          >
            <Link to={href01}>
              <img
                src={!brands.includes("glo") ? decor03 : decor01}
                alt="award-card-placeholder-image"
                loading="lazy"
                className="thumb"
              />
              <div className="content">
                <span className="click">{topCopy01}</span>
                <div className="bottom">
                  <h3
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(bottomCopy01)}}
                    className="copy"
                  />

                  <PlaceHolderIcon />
                </div>
              </div>
            </Link>
          </div>
          {brands.includes("glo") && (
            <div className="part part-bottom">
              <a href={href02} target="_blank" rel="noopener noreferrer">
                <img
                  src={decor02}
                  alt="secondary-award-card-placeholder-image"
                  loading="lazy"
                  className="thumb"
                />
                <div className="content">
                  <span className="click">{topCopy02}</span>
                  <div className="bottom">
                    <h3
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(bottomCopy02),
                      }}
                      className="copy"
                    />

                    <PlaceHolderIcon />
                  </div>
                </div>
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
